export const types =
[
    {id: "normal_folder", name: "תיקייה רגילה"},
    {id: "playfile", name: "השמעת קבצים"},
    {id: "menu", name: "תפריט"},
    {id: "record", name: "הקלטות"},
    {id: "voicemail_email", name: "הקלטת הודעה למייל"},
    {id: "recording_and_entering_data", name: "קבלת הקלטות ונתונים"},
    {id: "sale_products", name: "מכירת מוצרים"},
    {id: "go_to_folder", name: "מעבר לשלוחה אחרת"},
    {id: "queue", name: "ניתוב שיחה לפי תור"},
    {id: "routing", name: "ניתוב שיחה"},
    {id: "routing_yemot", name: "ניתוב למערכת אחרת"},
    {id: "routing_time", name: "ניתוב לפי זמנים"},
    {id: "routing_ip", name: "ניתוב ל  IP"},
    {id: "routing_1800", name: "ניתוב ל  1800"},
    {id: "credit_card", name: "סליקת אשראי"},
    {id: "trivia_questions", name: "טרוויה"},
    {id: "examination", name: "מבחנים"},
    {id: "points_say_total", name: "שמיעת הניקוד"},
    {id: "points_save", name: "הוספת ניקוד"},
    {id: "points_to_other_id", name: "הוספת ניקוד למשתמש אחר"},
    {id: "points_edit", name: "הוספת והורדת נקודות בידי מנהלים"},
    {id: "confbridge", name: "חדר ועידה  שידור חי"},
    {id: "playfile_time", name: "שידור חי מדומה"},
    {id: "study_tracking", name: "מעקב לימודים"},
    {id: "donation_campaign", name: "קמפיין התרמה"},
    {id: "donation_campaign_some_actions", name: "קמפיין התרמה פעולות נוספות"},
    {id: "time_keeper", name: "שעון נוכחות"},
    {id: "admin_login", name: "כניסה לניהול"},
    {id: "template_add_number", name: "הוספת מספר לרשימת התפוצה"},
    {id: "template_remove_number", name: "הסרת מספר מרשימת התפוצה"},
    {id: "id_list_message", name: "הודעות ונתונים אישיות"},
    {id: "id_message", name: "הודעות אישיות"},
    {id: "menu_voice", name: "תפריט זיהוי קולי"},
    {id: "template_filter", name: "הפניית מאזינים לפי רשימת תפוצה"},
    {id: "go_to_folder_time", name: "הפנייה לפי שעות וימים"},
    {id: "access_filter", name: "הפניית מאזינים לפי הגדרות זמנים ופעמים"},
    {id: "go_to_folder_from_list_all_information", name: "הפניית מאזינים לפי הנתונים"},
    {id: "go_to_folder_count", name: "הפניית מאזינים לפי כמות האנשים שעברו בשלוחה"},
    {id: "go_to_folder_date", name: "הפעלת שלוחה לפי תאריך"},
    {id: "folder_play_random", name: "הפנייה לשלוחות רנדומלי"},
    {id: "toplay_time", name: "השמעת הודעה לפי הגדרות זמנים ופעמים"},
    {id: "key_play_set_record_go_to_foldar", name: "כניסה ופעולות לפי מפתח"},
    {id: "hangup", name: "ניתוק שיחה"},
    {id: "block_id_type", name: "חסימת מאזין"},
    {id: "yemot_dialer_campaign_list", name: "ניהול רשימת התפוצה"},
    {id: "send_fax", name: "שליחת פקסים"},
    {id: "recv_fax", name: "מכירת מקומות"},
    {id: "sale_seats", name: "מכירת מקומות"},
    {id: "seker", name: "סקר"},
    {id: "tasks_report", name: "דיווח משימות יומי"},
    {id: "calculator_add_percentage", name: "מחשבון אחוזי תוספת"},
    {id: "daily_message", name: "השמעת הודעה יומית"},
    {id: "chapter_receive_mishnayot_select", name: "חלוקת משניות ולימודים"},
    {id: "chapter_receive", name: "חלוקת תהילים  גמרא  פרשות וכו"},
    {id: "tehillim_select_save_and_listen", name: "הקצאת פרקי תהילים קבועים"},
    {id: "zmanim", name: "זמני היום"},
    {id: "say_sabbath_time", name: "זמני שבת"},
    {id: "approval_number", name: "חלוקת מספרי אישור"},
    {id: "coupon", name: "חלוקת קופונים"},
    {id: "number_now_is", name: "השמעת המספר כעת"},
    {id: "say_hour_and_minute", name: "השעה כעת"},
    {id: "music_on_hold", name: "מוזיקה בהמתנה"},
    {id: "record_system_messages", name: "הקלטת הודעות מערכת"},
    {id: "api", name: "API"},
    {id: "yemot_dialer_campaign_start", name: "הפעלת קמפיין"},
    {id: "private_did_customer", name: "קבלת מספר אישי למערכת"},
    {id: "limit_call_seconds", name: "הגבלת זמן האזנה למאזין"},
    {id: "points_and_rating", name: "דירוג והוספת נקודות לעסקים"},
    {id: "phone_play_list", name: "רשימות השמעה"},
    {id: "fundraising", name: "מעקב גיוס תרומות"},
    {id: "start_select_file", name: "בחירה האם בהשמעת קבצים יהיה תפריט"}
]